// sidebarSlice.js
import { createSlice } from '@reduxjs/toolkit';

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: {
    activeSidebar: null,
    rightSidebarVisible: false // Add this new state
  },
  reducers: {
    setActiveSidebar: (state, action) => {
      state.activeSidebar = action.payload;
    },
    openRightSidebar: (state) => {
      state.rightSidebarVisible = true;
    },
    closeRightSidebar: (state) => {
      state.rightSidebarVisible = false;
    }
  },
});

export const { 
  setActiveSidebar, 
  openRightSidebar,
  closeRightSidebar
} = sidebarSlice.actions;

export default sidebarSlice.reducer;